import React from "react";
import { StyledContentWrapper } from "./PollItemContent.styled";

const PollItemContent = ({ children }: any) => {
    return <StyledContentWrapper>{children}</StyledContentWrapper>;
};

export default PollItemContent;
